import { InformationCircleIcon } from "@heroicons/react/24/solid";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Label } from "@/atoms-react/text/Text.react";
import { Document } from "@/features/user/document/types";
import { UploadFileV2 } from "../../upload-file.v2";
import { bronzeFormStyle } from "../bronze-form-style";
import { bronzeFormTranslation } from "../utils";

type BronzeFormUploadDocumentProps = {
  realIdentityUuid: string;
  logicalState: string;
  logicalStateSetter: (document: string) => void;
  translationKey: string;
};

export const BronzeFormUploadDocument = memo(
  (props: BronzeFormUploadDocumentProps) => {
    const { logicalState, logicalStateSetter, translationKey } = props;
    const t = useTranslation(["pass"]);

    return (
      <div className={bronzeFormStyle.containerLine}>
        <div className={bronzeFormStyle.containerLineTitle}>
          <Label className={bronzeFormStyle.containerLineTitleText}>
            {bronzeFormTranslation(t, `${translationKey}.title`)}
          </Label>
          <div className={bronzeFormStyle.tooltipContainer}>
            <InformationCircleIcon
              className={bronzeFormStyle.tooltipContainerIcon}
              data-tooltip={bronzeFormTranslation(t, `${translationKey}.tooltip`)}
              data-position="right"
            />
          </div>
        </div>
        <div className={bronzeFormStyle.containerLineContent}>
          <UploadFileV2
            realIdentityUuid={props.realIdentityUuid}
            dataCy={`bronze.form.${translationKey}`}
            documentsType={27} // Other
            uploadedFile={logicalState}
            className="w-full"
            setResponse={(uploaded: Document) => {
              logicalStateSetter(uploaded.UUID);
            }}
          />
        </div>
      </div>
    );
  },
  (prevProps: BronzeFormUploadDocumentProps, nextProps: BronzeFormUploadDocumentProps): boolean => {
    return prevProps.logicalState === nextProps.logicalState;
  }
);
